module.exports = __webpack_public_path__ + "img/24t.prt.e1605fa8.jpg";